document.body.addEventListener("click", async function(e) {
  const btn = e.target.closest(".share-btn");
  if (!btn) return; // not a .share-btn click

  e.preventDefault();

  const url = btn.dataset.shareUrl;

  if (navigator.share) {
    try {
      await navigator.share({
        url: url,
        title: document.title
      });
    } catch (err) {
      console.error("Sharing failed:", err);
    }
  } else {
    try {
      await navigator.clipboard.writeText(url);
      console.log("Link copied to clipboard!");
    } catch (err) {
      console.error("Clipboard copy failed:", err);
    }
  }
});
